import Vue from 'vue'


export const surveillenceEventBus = new Vue({
    data:{
            // map:null,
            // actions:null
    }

});